module.exports = __webpack_public_path__ + "static/media/collaboration-icon.26cad63e.svg";